import type { ListItemData } from "@ms/shared-components/components/GenericPanelList";
import { useState, useEffect, useCallback } from "react";
import { message } from "antd";
import { getRoles } from "../../roles/services/roleService";
import { buildRoleListItem } from "../config/listConfig";

interface UseRoleListReturn {
  roleList: ListItemData[];
  listLoading: boolean;
  fetchRoleList: () => Promise<void>;
  updateRolePermissionCount: (roleId: string, count: number) => void;
}

export const useRoleList = (roleIdFromUrl?: string | null): UseRoleListReturn => {
  const [roleList, setRoleList] = useState<ListItemData[]>([]);
  const [listLoading, setListLoading] = useState<boolean>(false);

  const fetchRoleList = useCallback(async () => {
    try {
      setListLoading(true);
      const response = await getRoles();

      // 直接使用返回的角色数组
      const roleData = Array.isArray(response) ? response : [];

      const listData: ListItemData[] = roleData.map(buildRoleListItem);

      setRoleList(listData);
    } catch (error) {
      message.error("获取角色列表失败");
      setRoleList([]);
    } finally {
      setListLoading(false);
    }
  }, []);

  const updateRolePermissionCount = useCallback((roleId: string, count: number) => {
    setRoleList((prevList) => {
      const updatedList = prevList.map((role) => {
        if (role.id === roleId) {
          return { ...role, rightContent: count.toString() };
        }
        return role;
      });
      return updatedList;
    });
  }, []);

  useEffect(() => {
    fetchRoleList();
  }, []);

  return {
    roleList,
    listLoading,
    fetchRoleList,
    updateRolePermissionCount,
  };
};
